import { useQuery } from "@tanstack/react-query";
import { getExchangeRates } from "../shared/currency";

// NOTE that baseCurrency doesn't really matter, because we always convert to the base currency first
// (see getLocalPriceNew in utils/prices or shared/currency)
export function useExchangeRates(baseCurrency: string = 'USD') {
    const query = useQuery({
        queryKey: ['exchangeRatesNew', baseCurrency],
        queryFn: () => getExchangeRates(baseCurrency),
        staleTime: 1000 * 60 * 10 // 10 minutes
    });

    // console.log(`query.data`, query.data);

    return query.data || {};
}
